import React, { type ReactNode } from "react";
import { Link } from "react-router-dom";
import { Button } from "./button.tsx";

interface LayoutProps {
  userEmail?: string | null;
  onSignOut?: () => void;
  children: ReactNode;
}

export function Layout({ userEmail, onSignOut, children }: LayoutProps) {
  return (
    <>
      <header className="flex items-center justify-between gap-4 border-b-2 border-ink px-4 py-4 sm:px-6">
        <Link
          to="/"
          className="shrink-0 font-mono text-base font-bold uppercase tracking-[0.15em] no-underline"
        >
          AUTHED.CO
        </Link>
        {userEmail ? (
          <div className="flex min-w-0 items-center gap-3 sm:gap-4">
            <span className="hidden min-w-0 truncate font-mono text-xs uppercase tracking-wider text-muted sm:inline">
              {userEmail}
            </span>
            <Button variant="secondary" size="sm" onClick={onSignOut}>
              Sign out
            </Button>
          </div>
        ) : null}
      </header>
      <main className="mx-auto w-full max-w-3xl px-4 py-10 sm:px-6 sm:py-12">
        {children}
      </main>
    </>
  );
}
